import { MemberListMember } from '../../../components/Member';
import { usePageTitle } from '../../../hooks';

export function Members() {
  usePageTitle('member:title');
  return <MemberListMember />;
}
